import type { ClassEnrollmentResult } from "../../../cbi-generator/generated/dto/ClassEnrollmentResult";
import type { OrderRef } from "../../../cbi-generator/generated/dto/OrderRef";
import { SignupTypeEnum } from "../../../cbi-generator/generated/dto/SignupTypeEnum";
import { ProgramTypeKey } from "../../../cbi-generator/generated/dto/ProgramTypeKey";

export function staffEnrollmentProgram(programId: number): ProgramTypeKey {
  switch (programId) {
    case 1:
      return ProgramTypeKey.ADULT_PROGRAM;
    case 2:
      return ProgramTypeKey.JUNIOR_PROGRAM;
    case 3:
      return ProgramTypeKey.UNIVERSAL_ACCESS_PROGRAM;
    case 4:
      return ProgramTypeKey.HIGH_SCHOOL;
    default:
      throw new Error(
        "Unknown class program. Reload the class before enrolling.",
      );
  }
}

export function staffCheckoutOrder(
  result: ClassEnrollmentResult,
): OrderRef | null {
  if (result.signupType !== SignupTypeEnum.PURCHASE_HOLD) return null;
  if (
    !result.order ||
    !Number.isSafeInteger(result.order.assignId) ||
    result.order.assignId <= 0
  ) {
    throw new Error(
      "The purchase-held signup did not return an order. Reload enrollment before retrying.",
    );
  }
  return result.order;
}
